@if (busy()) {
  <div class="flex flex-col grow justify-center items-center -translate-y-32">
    <mat-spinner class="m-2" color="primary" [diameter]="96"></mat-spinner>
    <label class="m-2">{{ translations.login.authorizing.label.text }}</label>
  </div>
}

@if (error()) {
  <div class="flex flex-col grow justify-center items-center -translate-y-32">
    <div class="py-2">{{ translations.login.failed.label.text }}</div>
    <button modus-flat-button color="primary" (click)="tryLoginAgain()">
      {{ translations.login.retry.button.text }}
    </button>
  </div>
}
